var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58789 1.30859C4.79093 1.30859 1.71289 4.38664 1.71289 8.18359C1.71289 11.9806 4.79093 15.0586 8.58789 15.0586C12.3848 15.0586 15.4629 11.9806 15.4629 8.18359C15.4629 4.38664 12.3848 1.30859 8.58789 1.30859ZM0.462891 8.18359C0.462891 3.69628 4.10058 0.0585938 8.58789 0.0585938C13.0752 0.0585938 16.7129 3.69628 16.7129 8.18359C16.7129 12.6709 13.0752 16.3086 8.58789 16.3086C4.10058 16.3086 0.462891 12.6709 0.462891 8.18359ZM7.75456 4.43359C7.75456 3.97336 8.12765 3.60026 8.58789 3.60026C9.04813 3.60026 9.42122 3.97336 9.42122 4.43359C9.42122 4.89383 9.04813 5.26693 8.58789 5.26693C8.12765 5.26693 7.75456 4.89383 7.75456 4.43359ZM9.21289 12.3503V6.51693H7.96289V12.3503H9.21289Z",
    fill: "#B5B6C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowDetailIcon);
export default __webpack_public_path__ + "static/media/show-detail-icon.71d538a73271864b26fc56b5f689fab3.svg";
export { ForwardRef as ReactComponent };